const rest_api = process.env.REACT_APP_REST_API_URL;

export const rest_api_url = {
  login: `${rest_api}/v1/auth/log-in`,
  refresh_token: `${rest_api}/v1/auth/refresh-token`,
  check_token: `${rest_api}/v1/auth/check-token`,
  user_reinvite: `${rest_api}/v1/user/re-invite`,
  user_reser_mfa: `${rest_api}/v1/user/reset-mfa`,
  user_data: `${rest_api}/v1/user`,
  user_edit: `${rest_api}/v1/user`,
  user_change_partner: `${rest_api}/v1/user/change-partner`,
  create_client: `${rest_api}/v1/client`,
  setup_mfa_url: `${rest_api}/v1/auth/mfa/setup_mfa`,
  verify_mfa_token_url: `${rest_api}/v1/auth/mfa/verify_mfa_token`,
  change_mfa_status_url: `${rest_api}/v1/auth/mfa/change_mfa_status`,
  mfa_signIn_verify: `${rest_api}/v1/auth/mfa/token-verify`,
  payment_request_data: `${rest_api}/v1/user/payment-request-data`,
  invite_user: `${rest_api}/v1/invite/user`,
  edit_user_information: `${rest_api}/v1/user/information`,
  get_dashboard_data: `${rest_api}/v1/dashboard`,
  edit_user_bank_data: `${rest_api}/v1/user-bank`,
  edit_user_details: `${rest_api}/v1/back-office/client-information/user-details`,
  new_user_password: `${rest_api}/v1/auth/new-password`,
  change_password: `${rest_api}/v1/auth/change-password`,
  forgot_password: `${rest_api}/v1/auth/forgot-password`,
  confirm_password: `${rest_api}/v1/auth/confirm-password`,
  check_out_token_payment: `${rest_api}/v1/payment/checkout/get_token`,
  check_out_token_withdrawal: `${rest_api}/v1/withdrawal/checkout/get_token`,
  transaction_list: `${rest_api}/v1/transaction_list/get?`,
  change_status_withdrawal: `${rest_api}/v1/requested_withdrawal/change_status`,
  change_payment_method: `${rest_api}/v1/requested_withdrawal/change_payment_method`,
  back_office_api_key: `${rest_api}/v1/back-office/api-key`,
  back_office_api_key_2: `${rest_api}/v2/back-office/api-key`,
  back_office_domain: `${rest_api}/v1/back-office/domain`,
  back_office_webhook: `${rest_api}/v1/back-office/webhook`,
  back_office_domain_v2: `${rest_api}/v2/back-office/domain`,
  back_office_client_user: `${rest_api}/v1/back-office/client-user`,
  back_office_client_user_v2: `${rest_api}/v2/back-office/client-user`,
  back_office_routing_group: `${rest_api}/v1/back-office/routing-group`,
  back_office_routing_rule: `${rest_api}/v1/back-office/routing-rule`,
  back_office_routing_list_order: `${rest_api}/v1/back-office/routing-list-order`,
  back_office_provider_rules: `${rest_api}/v1/back-office/provider-rules`,
  back_office_credentials: `${rest_api}/v1/back-office/credentials`,
  back_office_credentials_v2: `${rest_api}/v2/back-office/credentials`,
  back_office_provider_group: `${rest_api}/v1/back-office/provider-group`,
  back_office_provider_sort: `${rest_api}/v1/back-office/provider-sort`,
  back_office_provider_sort_order: `${rest_api}/v1/back-office/provider-sort-order`,
  back_office_available_providers: `${rest_api}/v1/back-office/providers/available`,
  back_office_available_providers_v2: `${rest_api}/v2/back-office/providers/available`,
  back_office_enabled_providers: `${rest_api}/v1/back-office/providers/enabled`,
  back_office_payout_providers: `${rest_api}/v1/back-office/providers/payouts`,
  back_office_users: `${rest_api}/v1/back-office/users`,
  back_office_users_v2: `${rest_api}/v2/back-office/users`,
  back_office_reporting: `${rest_api}/v1/back-office/reporting`,
  back_office_generated_reports: `${rest_api}/v1/back-office/generated-reports`,
  back_office_reporting_v2: `${rest_api}/v2/back-office/reporting`,
  back_office_client_information: `${rest_api}/v1/back-office/client-information`,
  back_office_vendor: `${rest_api}/v1/back-office/vendor`,
  back_office_vendors: `${rest_api}/v1/back-office/vendors`,
  back_office_settings: `${rest_api}/v1/back-office/settings`,
  back_office_settings_v2: `${rest_api}/v2/back-office/settings`,
  back_office_provider_error_messages: `${rest_api}/v1/back-office/provider-error-messages`,
  back_office_provider_error_messages_codes: `${rest_api}/v1/back-office/provider-error-messages/codes`,
  back_office_checkout_translations: `${rest_api}/v1/back-office/checkout-translations`,
  back_office_audit_logs: `${rest_api}/v1/back-office/audit-logs`,
  back_office_transaction_failures: `${rest_api}/v1/back-office/reporting/transaction-failures`,
  back_office_general: `${rest_api}/v1/back-office/general`,
  back_office_email_templates: `${rest_api}/v1/back-office/email-templates`,
  back_office_email_templates_v2: `${rest_api}/v2/back-office/email-templates`,
  back_office_style: `${rest_api}/v1/back-office/style`,
  back_office_transactions: `${rest_api}/v1/back-office/transactions`,
  back_office_transactions_v2: `${rest_api}/v2/back-office/transactions`,
  back_office_transaction_information: `${rest_api}/v1/back-office/transaction-information`,
  back_office_transaction_overview: `${rest_api}/v1/back-office/transaction-overview`,
  back_office_requested_withdrawal_information: `${rest_api}/v1/back-office/requested-withdrawal-information`,
  back_office_dashboard: `${rest_api}/v1/back-office/dashboard`,
  back_office_blocklist: `${rest_api}/v1/back-office/blocklist`,
  blocklist_user_details: `${rest_api}/v1/back-office/blocklist/user`,
  backoffice_provider_clone: `${rest_api}/v1/back-office/provider/clone`,
  back_office_user_segments: `${rest_api}/v1/back-office/user-segments`,
  back_office_provider_user_segments: `${rest_api}/v1/back-office/provider-user-segments`,
  // NIXXE CRYPTO URLs
  back_office_crypto_dashboard: `${rest_api}/v1/back-office/crypto/dashboard`,
  back_office_wallet_address: `${rest_api}/v1/back-office/wallet-address`,
  back_office_transaction_history: `${rest_api}/v1/back-office/transaction-history`,
  back_office_customer_wallets: `${rest_api}/v1/back-office/customer-wallets`,
  back_office_crypto_deposit_funds: `${rest_api}/v1/back-office/crypto/deposit-funds`,
  back_office_crypto_deposit_data: `${rest_api}/v1/back-office/crypto/deposit-data`,
  back_office_crypto_withdraw_funds: `${rest_api}/v1/back-office/crypto/withdraw-funds`,
  back_office_crypto_transfer_between_wallets: `${rest_api}/v1/back-office/crypto/transfer-between-wallets`,
  generate_payment_link: `${rest_api}/v1/generate_payment_link`,
};
